export const name = '$gzAlertDialog';

export default function $gzAlertDialog($mdDialog) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var service = {
    show: show,
  };

  return service;

  /////////////////

  function show(options) {
    return $mdDialog.show({
      template: require('./alert-dialog.jade'),
      escapeToClose: false,
      controller: 'AlertDialogController',
      bindToController: true,
      controllerAs: 'vm',
      locals: options
    });
  }

} //$gzAlertDialog
